import type { MerchantStat, Transaction } from '@/modules/projects/stores/types'

export function parseOriginalNames(originalNames: string): string[] {
  return originalNames
    .split(',')
    .map((name) => name.trim())
    .filter((name) => name.length > 0)
}

export function merchantNames(merchant: MerchantStat): string[] {
  return merchant.names ?? parseOriginalNames(merchant.originalNames)
}

export function matchMerchantTransactions(
  merchant: MerchantStat,
  transactions: Transaction[],
): Transaction[] {
  const aliases = new Set(
    merchantNames(merchant).map((name) => name.toLowerCase()),
  )
  if (aliases.size === 0) return []
  return transactions
    .filter((transaction) =>
      aliases.has((transaction.merchant ?? '').toLowerCase()),
    )
    .sort((first, second) => Math.abs(second.amount) - Math.abs(first.amount))
}
